import styled from 'styled-components'

import { Text } from '~/shared/components'
import { flexRow } from '~/shared/styles/layout'

export const Wrapper = styled.div`
  ${flexRow}
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 8px;
`

export const Message = styled(Text)`
  margin: 0px 8px;
  letter-spacing: -0.225px;
`
